import React from 'react';
import './style.css';

const Footer = (props) => {
  return (
    <footer className="Footer">
      <section>
        Designed and built with{' '}
        <span className="Footer__Heart">&hearts;</span> by{' '}
        <a
          href="https://www.linkedin.com/in/khushwant-mali-636b26276/"
          target="_blank"
          rel="noopener noreferrer"
          className="Footer__Link"
        >
          KHUSHWANT MALI
        </a>
      </section>

      <section className="Footer__Items">
        <a
          href="https://github.com/khushwant108/Sorting_Visualizer"
          target="_blank"
          rel="noopener noreferrer"
          className="Footer__Link"
        >
          Code
        </a>
      </section>
    </footer>
  );
};

export default Footer;
